import React from "react";

// Generic error boundary: if the wrapped subtree throws during render
// (e.g. a third-party widget failing because of a missing env var or a
// network hiccup), only that subtree is replaced with `fallback` -
// the rest of the page keeps rendering normally instead of the whole
// page going blank. React error boundaries must be class components.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback ?? null;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
